export enum ExpPromoteMobileAppBanner {
  A = 'exp_lu_promote_mobile_app_top_banner_ver_a',
  B = 'exp_lu_promote_mobile_app_top_banner_ver_b',
}
